import React, { useState } from "react";
import { ADMIN_URL } from "../../Utils/AppConstance";
import { useNavigate } from "react-router-dom";
export default function useLogin(setIsLogin) {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const loginUser = async () => {
    try {
      const response = await fetch(ADMIN_URL + "/user/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: username,
          password: password,
        }),
      });
      if (response.status == 200) {
        const userData = await await response.json();
        localStorage.setItem("token", userData.token);
        localStorage.setItem("user-id", userData.id);
        localStorage.setItem("user-role", userData.role);
        localStorage.setItem("user-name", userData.name);
        localStorage.setItem("user-code", userData.code);
        localStorage.setItem("isLogin", "true");
        localStorage.setItem(
          "user-permission",
          JSON.stringify(userData?.permissions)
        );
        const platformAccess = userData.platforms.find((x) => x.id === 4);
        if (platformAccess) {
          setIsLogin(true);
          navigate("/mySpace", { replace: true });
        } else {
          alert("The user don't have the platform access");
        }
      } else if (response.status == 404) {
        alert("You have entered an invalid username or password");
      }
    } catch (error) {
      console.log("err==================", error);
    }
  };

  return {
    password,
    username,
    setPassword,
    setUsername,
    loginUser,
  };
}
